import produce from "immer";

const INITIAL_STATE = { id: null, sub1: null, sub2: null };

const Category = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_ID":
      return produce(state, (draft) => {
        draft.id = action.id;
      });

    case "SET_SUB1":
      return produce(state, (draft) => {
        draft.sub1 = action.id;
      });

    case "SET_SUB2":
      return produce(state, (draft) => {
        draft.sub2 = action.id;
      });

    case "CLEAR_CATEGORY":
      return { id: null, sub1: null, sub2: null };
    default:
      return state;
  }
};

export default Category;
